module.exports = __webpack_public_path__ + "img/none.4f5b0379.png";